// Generated by purs version 0.15.15
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Hashable from "../Data.Hashable/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Void from "../Data.Void/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_VDom_DOM_StringRenderer from "../Halogen.VDom.DOM.StringRenderer/index.js";
import * as Record from "../Record/index.js";
import * as Visonum_Cross_Style from "../Visonum.Cross.Style/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var map1 = /* #__PURE__ */ Data_Functor.map(Halogen_HTML_Core.functorHTML);
var bimap = /* #__PURE__ */ Data_Bifunctor.bimap(Halogen_HTML_Core.bifunctorHTML);
var union = /* #__PURE__ */ Record.union();
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var hash = /* #__PURE__ */ Data_Hashable.hash(Data_Hashable.hashableString);
var AppHTML_ = function (x) {
    return x;
};
var functorAppHTML = {
    map: function (f) {
        return function (m) {
            return map(map1(f))(m);
        };
    }
};
var bifunctorAppHTML = {
    bimap: function (f) {
        return function (g) {
            return function (v) {
                return function (ctx) {
                    return bimap(f)(g)(v(ctx));
                };
            };
        };
    }
};
var toHTML = function (ctx) {
    return function (v) {
        return v(ctx);
    };
};
var withCtx = function (f) {
    return function (ctx) {
        return toHTML(ctx)(f(ctx));
    };
};
var styledUI = function (dictIsStyles) {
    var toCss = Visonum_Cross_Style.toCss(dictIsStyles);
    return function () {
        return function (ui) {
            return function (mkStyles) {
                return function (props) {
                    return withCtx(function (ctx) {
                        var style = toCss(mkStyles(ctx));
                        return ui(union(props)({
                            style: style
                        }));
                    });
                };
            };
        };
    };
};
var styledNode = function (dictIsStyles) {
    var toCss = Visonum_Cross_Style.toCss(dictIsStyles);
    return function (elem) {
        return function (mkStyles) {
            return function (attrs) {
                return function (children) {
                    return function (ctx) {
                        var v = toCss(mkStyles(ctx));
                        return elem(append(attrs)([ Halogen_HTML_Properties.style(v) ]))(map2(toHTML(ctx))(children));
                    };
                };
            };
        };
    };
};
var styledNode_ = function (dictIsStyles) {
    var styledNode1 = styledNode(dictIsStyles);
    return function (el) {
        return function (st) {
            return styledNode1(el)(Data_Function["const"](st));
        };
    };
};
var styledLeaf = function (dictIsStyles) {
    var toCss = Visonum_Cross_Style.toCss(dictIsStyles);
    return function (elem) {
        return function (mkStyles) {
            return function (attrs) {
                return function (ctx) {
                    var v = toCss(mkStyles(ctx));
                    return elem(append(attrs)([ Halogen_HTML_Properties.style(v) ]));
                };
            };
        };
    };
};
var styledLeaf_ = function (dictIsStyles) {
    var styledLeaf1 = styledLeaf(dictIsStyles);
    return function (el) {
        return function (st) {
            return styledLeaf1(el)(Data_Function["const"](st));
        };
    };
};
var scopedHtml = function (mkHtml) {
    var v = mkHtml({
        unique: "$unique"
    });
    var vdomStr = Halogen_VDom_DOM_StringRenderer.render(Data_Function["const"](""))(v);
    var unique = "hashed" + show(hash(vdomStr));
    var html = mkHtml({
        unique: unique
    });
    return {
        unique: unique,
        html: html
    };
};
var mapCtx = function (f) {
    return function (v) {
        return function ($46) {
            return v(f($46));
        };
    };
};
var from_ = /* #__PURE__ */ Data_Bifunctor.lmap(bifunctorAppHTML)(Data_Void.absurd);
var fromHTML = function (html) {
    return function (v) {
        return html;
    };
};
var text = function ($47) {
    return fromHTML(Halogen_HTML_Core.text($47));
};
var none = /* #__PURE__ */ text("");
var defaultAppHTML = {
    def: /* #__PURE__ */ text("")
};
export {
    AppHTML_,
    fromHTML,
    from_,
    mapCtx,
    none,
    scopedHtml,
    styledLeaf,
    styledLeaf_,
    styledNode,
    styledNode_,
    styledUI,
    text,
    toHTML,
    withCtx,
    bifunctorAppHTML,
    defaultAppHTML,
    functorAppHTML
};
